export var TypeActionTrade;
(function (TypeActionTrade) {
    TypeActionTrade["Buy"] = "Trade > Buy";
    TypeActionTrade["BuyConfirmed"] = "Trade > BuyConfirmed";
    TypeActionTrade["Sell"] = "Trade > Sell";
})(TypeActionTrade || (TypeActionTrade = {}));
export var actionSellProduct = function (itemId, amount) { return ({
    amount: amount,
    itemId: itemId,
    type: TypeActionTrade.Sell,
}); };
export var actionBuyProduct = function (itemId, amount) { return ({
    amount: amount,
    itemId: itemId,
    type: TypeActionTrade.Buy,
}); };
export var actionBuyProductConfirmed = function (itemId, amount) { return ({
    amount: amount,
    itemId: itemId,
    type: TypeActionTrade.BuyConfirmed,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/trade-component/actionTrade.ts
// module id = 250
// module chunks = 3